import { AuthService } from './../../../../service/auth.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faKey, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { Callback } from '../../login.component';
import { AgentDto } from '../../../../service/dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-login-capture-username',
	templateUrl: './login-capture-username.component.html',
	styleUrl: './login-capture-username.component.scss',
	standalone: false
})
export class LoginCaptureUsernameComponent implements OnInit {
	@Input() agent?: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();
	form!: FormGroup;
	submitting: boolean = false;

	faUser = faUser;
	faKey = faKey;
	faLock = faLock;
	message?: string;

	constructor(private fb: FormBuilder, private authService: AuthService) {
	}
	ngOnInit(): void {
		this.form = this.fb.group({
			username: [this.agent?.username, [Validators.required, Validators.minLength(4)]]
		});
	}
	onSubmit() {
		if (!this.agent) {
			this.agent = {
				id: -1,
				username: '',
				createdAt: new Date(),
				status: 'PendingRegistration',
				hashCode: 0
			}
		}
		this.agent.username = this.form.get('username')!.value;

		this.submitting=true;
		this.authService.checkAgentState(this.agent!)
			.pipe(finalize(()=> this.submitting = false))
			.subscribe(result => {
				if (result.success == false) {
					this.message = "Username does not exist."
				}
				switch (result.agent!.status) {
					case 'PendingRegistration': return this.doUpdateState.emit({ mode: 'CaptureRegistrationOtp', agent: result.agent });
					case 'PendingApproval': return this.doUpdateState.emit({ mode: 'PendingApproval', agent: result.agent });
					case 'Rejected': return this.doUpdateState.emit({ mode: 'Rejected', agent: result.agent });
					case 'Approved': return this.doUpdateState.emit({ mode: 'CapturePassword', agent: result.agent });
					case 'Blocked': return this.doUpdateState.emit({ mode: 'Blocked', agent: result.agent });
					case 'BlockedOtp': return this.doUpdateState.emit({ mode: 'Blocked', agent: result.agent });
					case 'Suspended': return this.doUpdateState.emit({ mode: 'Suspended', agent: result.agent });
				}
			})
	}
}
